import { render, staticRenderFns } from "./MerchandisingProductCharacteristics.vue?vue&type=template&id=3d7de408&scoped=true"
import script from "./MerchandisingProductCharacteristics.vue?vue&type=script&lang=js"
export * from "./MerchandisingProductCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./MerchandisingProductCharacteristics.vue?vue&type=style&index=0&id=3d7de408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7de408",
  null
  
)

export default component.exports